import request, { extend } from 'umi-request';

// 请求拦截器
// request.interceptors.request.use((url, options) => {
//   const arr = document.cookie.split(';');
//   let c_token: string = '';
//   arr.map((v) => {
//     if (v.includes('__x-auth-token=')) c_token = v.split('=')[1];
//   });
//   let headers: any = null;
//   // if (c_token && (!url.includes('.autohome.com') || url.includes(window.location.origin)) ) {
//   if (c_token) {
//     headers = {
//       'x-auth-token': c_token,
//     };
//   }
//   return {
//     url,
//     options: { ...options, headers: { ...options.headers, ...headers } },
//   };
// });

// 响应拦截器
// request.interceptors.response.use(async response => {
//     const data = await response.clone().json();
//     if (data && data.NOT_LOGIN) {
//         location.href = '登录url';
//     }
//     return response;
// });

/**
 * request 网络请求工具
 * 更详细的 api 文档: https://github.com/umijs/umi-request
 */
const codeMessage: any = {
  200: '服务器成功返回请求的数据。',
  201: '新建或修改数据成功。',
  202: '一个请求已经进入后台排队（异步任务）。',
  204: '删除数据成功。',
  400: '发出的请求有错误，服务器没有进行新建或修改数据的操作。',
  401: '用户没有权限（令牌、用户名、密码错误）。',
  403: '用户得到授权，但是访问是被禁止的。',
  404: '发出的请求针对的是不存在的记录，服务器没有进行操作。',
  406: '请求的格式不可得。',
  410: '请求的资源被永久删除，且不会再得到的。',
  422: '当创建一个对象时，发生一个验证错误。',
  500: '服务器发生错误，请检查服务器。',
  502: '网关错误。',
  503: '服务不可用，服务器暂时过载或维护。',
  504: '网关超时。',
};

/**
 * 异常处理程序
 */
const errorHandler = (error: { response: Response }): Response => {
  const { response } = error;
  // if (response && response.status) {
  //   const errorText = codeMessage[response.status] || response.statusText;
  //   const { status, url } = response;

  //   // console.log(`请求错误 ${status}: ${url}`);
  //   // console.log(errorText);
  // } else if (!response) {
  //   console.log('您的网络发生异常，无法连接服务器');
  // }
  return response;
};

/**
 * 配置request请求时的默认参数
 */

const requestFunction = (url: string, queryData: any, option = {}) => {
  const { body, method } = queryData;

  let _method = method.toLowerCase();

  // 处理get请求和post请求的请求数据
  let _data = method === 'GET' ? { params: body } : { data: body };

  return request(url, {
    method: _method,
    // useCache: true, // 缓存get请求
    // credentials: 'include', // 默认请求是否带上cookie
    errorHandler, // 错误处理
    ..._data, // 请求数据
    ...option, // 自定义配置
    // headers: {
    //   'X-Requested-with': 'XMLHttpRequest',
    // },
  }).then((res: any) => {
    const _status = (res || {}).status || 0;
    // _status === 99 && history.replace('/login');
    return res;
  });
};

export default requestFunction;

export const requestNoCred = extend({
  errorHandler, // 默认错误处理
});
